import script from "./ContentHighlightsEditModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentHighlightsEditModal.vue?vue&type=script&lang=ts&setup=true"

import "./ContentHighlightsEditModal.vue?vue&type=style&index=0&id=3f9dd7db&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f9dd7db"]])

export default __exports__